import { useEffect, useRef } from 'react';
import './placeholder.css'
import uuid from 'react-uuid';
import Overlay from '../overlay/Overlay';
import ContentGrid from '../ContentGrid';
import Spacer from '../Spacer';
import PlaceHolderService, { IPlaceHolderService } from './PlaceHolderService';

interface PulseListPlaceholderProps {
    count?: number,
    title?: string,
    titleIcon?: string,
    size?: string
}
export const PulseListPlaceholder = ({
    count = 3,
    title,
    titleIcon,
    size = "large"
}: PulseListPlaceholderProps) => {

    const ref = useRef<HTMLDivElement>(null);
    const service: IPlaceHolderService = new PlaceHolderService();

    useEffect(() => {
        const guid = uuid();
        let i = 0;

        const height = service.getHeight(size);

        let interval = setInterval(() => {
            if (i % count === 0 ) {
                for (let j = 0; j <= i; j++) {
                    const element = document.getElementById(`${guid}-${j}`);
                    element?.remove();
                }
            }

            const shimmer = document.createElement("div");
            shimmer.id = `${guid}-${i}`;
            shimmer.className = "pulse";
            shimmer.style.height = `${height}px`;
            ref.current?.insertAdjacentElement('beforeend', shimmer);

            i++;

        }, 500);

        return (() => {
            clearInterval(interval);
        });

    }, []);

    return (
        <>
            <ContentGrid
                title={title}
                titleIcon={titleIcon}
                showOfflineWarning={false}>
                <Spacer height={20} />
                <PulseListPlaceholderContent ref={ref} />
            </ContentGrid>
            <Overlay isBusy = { true} />
        </>
    )
}

interface PulseListPlaceholderContentProps {
    ref?: any
}
const PulseListPlaceholderContent = ({ ref }: PulseListPlaceholderContentProps) => {
    return (
        <div
            ref={ref}
            className="k-gap-2 pulse-placeholder"
            role="placeholder"
        />
    )
}

